<!--  -->
<template>
  <div>
    <el-form label-position="right" label-width="50px" :model="formLabelAlign">
      <el-form-item label="名称">
        <el-input v-model="formLabelAlign.name" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { assortstore, assortupdate } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      type: null,
      formLabelAlign: {
        name: ''
      },
      id: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(type, item) {
      this.type = type
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        console.log('新增')
      } else {
        this.formLabelAlign.name = item.name
        this.id = item.id
      }
    },
    async sumbit() {
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.name == '') {
        this.$message.error('请填写找茬配置类型')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        await assortstore({
          name: this.formLabelAlign.name
        })
        this.$message({
          message: '新增成功',
          type: 'success'
        })
        this.$emit('updata')
      }
      // eslint-disable-next-line eqeqeq
      if (this.type == 2) {
        await assortupdate({
          name: this.formLabelAlign.name,
          id: this.id
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updata')
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
